export function connectorTypeToIntegrationSlug(type: string): string {
  return type.replace(":", "-").toLowerCase();
}
